export const VERTICAL_TYPES = {
  LEARN: 'LEARN',
  META: 'META',
} as const;

export type VerticalType =
  (typeof VERTICAL_TYPES)[keyof typeof VERTICAL_TYPES];

export const LOGIN_FLOW_TYPES = {
  ADMISSION_ID: 'ADMISSION_ID',
  MOBILE_NUMBER: 'MOBILE_NUMBER',
} as const;

export type LoginFlowType =
  (typeof LOGIN_FLOW_TYPES)[keyof typeof LOGIN_FLOW_TYPES];

export const AUTH_METHOD_TYPES = {
  PASSWORD: 'PASSWORD',
  OTP: 'OTP',
  BOTH: 'BOTH',
} as const;

export type AuthMethodType =
  (typeof AUTH_METHOD_TYPES)[keyof typeof AUTH_METHOD_TYPES];

export const LOGIN_COMPONENTS = {
  LOGIN_WITH_NUMBER: 'LoginWithNumber',
  LOGIN_WITH_ADMISSION_NO: 'LoginWithAdmissionNo',
} as const;

export type LoginComponent =
  (typeof LOGIN_COMPONENTS)[keyof typeof LOGIN_COMPONENTS];

export interface GatewayConfiguration {
  productId: number;
  tenantId: number;
}

export interface BrandingConfiguration {
  logo: string;
  favicon?: string;
  portalTitle: string;
}

export interface ThemeConfiguration {
  primaryColor: string;
  secondaryColor: string;
}

export interface LoginConfig {
  component: LoginComponent;
  loginFlow: LoginFlowType;
  authMethod: AuthMethodType;
}

export interface DashboardConfig {
  evaluationPhases: boolean;
}

export interface EvaluationConfig {
  reportError: boolean;
  l1EvaluationReport: boolean;
  singleQuestionFlow: boolean;
  multiQuestionFlow: boolean;
  questionNavigation: boolean;
}

export interface VerticalConfig {
  vertical: VerticalType;
  gatewayConfiguration: GatewayConfiguration;
  branding: BrandingConfiguration;
  theme: ThemeConfiguration;
  features: {
    login: LoginConfig;
    dashboard: DashboardConfig;
    evaluation: EvaluationConfig;
  };
}
